var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 40,
    viewBox: "0 0 81 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_51_5340)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.6173 37.4968C24.6173 37.8946 24.5562 38.2431 24.4458 38.5188C24.3335 38.7944 24.1877 39.0288 24.0083 39.204C23.827 39.3871 23.622 39.5112 23.3993 39.5919C23.1668 39.6726 22.9441 39.714 22.7214 39.714H21.2886C20.8432 39.714 20.4471 39.6628 20.1042 39.5506C19.7691 39.4383 19.4518 39.2434 19.1424 38.9579C18.8428 38.6724 18.5334 38.2844 18.2319 37.7922C17.9323 37.3019 17.6052 36.658 17.2623 35.8822L7.32153 13.8445C6.7973 12.7103 6.27504 11.5151 5.7508 10.2687C5.21869 9.02224 4.72993 7.80536 4.27467 6.6318H4.22343C4.25693 8.06133 4.28453 9.53419 4.30029 11.0346C4.31803 12.5272 4.32591 14.0177 4.32591 15.4886V38.8752C4.32591 39.0189 4.29241 39.1508 4.22343 39.2847C4.14657 39.4068 4.02635 39.5092 3.86277 39.5801C3.69131 39.651 3.4765 39.712 3.20255 39.7632C2.92861 39.8144 2.57584 39.8341 2.15606 39.8341C1.72642 39.8341 1.37562 39.8144 1.09971 39.7632C0.825766 39.712 0.610949 39.651 0.455255 39.5801C0.291679 39.5092 0.181314 39.4068 0.102482 39.2847C0.0335036 39.1528 0 39.0189 0 38.8771V3.12687C0 2.3294 0.189197 1.75837 0.575475 1.41969C0.951898 1.08298 1.36577 0.909705 1.81905 0.909705H3.94752C4.44613 0.909705 4.86591 0.9609 5.20095 1.06329C5.54387 1.15584 5.8454 1.32911 6.11146 1.55359C6.37752 1.77806 6.64358 2.10492 6.8919 2.51449C7.14022 2.92405 7.40628 3.43404 7.68219 4.05823L15.321 21.0591C15.794 22.1007 16.2473 23.1128 16.6848 24.1033C17.1223 25.0937 17.552 26.0645 17.956 27.0254C18.36 27.9764 18.762 28.9255 19.1582 29.8549C19.5622 30.7744 19.9485 31.7137 20.3426 32.6549H20.3682C20.3347 31.0718 20.3072 29.4355 20.2993 27.7303C20.2914 26.0231 20.2914 24.3789 20.2914 22.8057V1.8076C20.2914 1.66386 20.3249 1.53193 20.3939 1.41969C20.4707 1.29761 20.591 1.19522 20.7545 1.10267C20.926 1.01013 21.1487 0.949086 21.4147 0.907736C21.6887 0.866386 22.0493 0.846695 22.4967 0.846695C22.883 0.846695 23.218 0.866386 23.5018 0.907736C23.7856 0.949086 24.0083 1.01013 24.162 1.10267C24.3256 1.19522 24.436 1.29761 24.5148 1.41969C24.5838 1.53193 24.6173 1.66582 24.6173 1.8076V37.4968Z",
    fill: "url(#paint0_linear_51_5340)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_51_5340",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 40
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.6173 37.4968C24.6173 37.8946 24.5562 38.2431 24.4458 38.5188C24.3335 38.7944 24.1877 39.0288 24.0083 39.204C23.827 39.3871 23.622 39.5112 23.3993 39.5919C23.1668 39.6726 22.9441 39.714 22.7214 39.714H21.2886C20.8432 39.714 20.4471 39.6628 20.1042 39.5506C19.7691 39.4383 19.4518 39.2434 19.1424 38.9579C18.8428 38.6724 18.5334 38.2844 18.2319 37.7922C17.9323 37.3019 17.6052 36.658 17.2623 35.8822L7.32153 13.8445C6.7973 12.7103 6.27504 11.5151 5.7508 10.2687C5.21869 9.02224 4.72993 7.80536 4.27467 6.6318H4.22343C4.25693 8.06133 4.28453 9.53419 4.30029 11.0346C4.31803 12.5272 4.32591 14.0177 4.32591 15.4886V38.8752C4.32591 39.0189 4.29241 39.1508 4.22343 39.2847C4.14657 39.4068 4.02635 39.5092 3.86277 39.5801C3.69131 39.651 3.4765 39.712 3.20255 39.7632C2.92861 39.8144 2.57584 39.8341 2.15606 39.8341C1.72642 39.8341 1.37562 39.8144 1.09971 39.7632C0.825766 39.712 0.610949 39.651 0.455255 39.5801C0.291679 39.5092 0.181314 39.4068 0.102482 39.2847C0.0335036 39.1528 0 39.0189 0 38.8771V3.12687C0 2.3294 0.189197 1.75837 0.575475 1.41969C0.951898 1.08298 1.36577 0.909705 1.81905 0.909705H3.94752C4.44613 0.909705 4.86591 0.9609 5.20095 1.06329C5.54387 1.15584 5.8454 1.32911 6.11146 1.55359C6.37752 1.77806 6.64358 2.10492 6.8919 2.51449C7.14022 2.92405 7.40628 3.43404 7.68219 4.05823L15.321 21.0591C15.794 22.1007 16.2473 23.1128 16.6848 24.1033C17.1223 25.0937 17.552 26.0645 17.956 27.0254C18.36 27.9764 18.762 28.9255 19.1582 29.8549C19.5622 30.7744 19.9485 31.7137 20.3426 32.6549H20.3682C20.3347 31.0718 20.3072 29.4355 20.2993 27.7303C20.2914 26.0231 20.2914 24.3789 20.2914 22.8057V1.8076C20.2914 1.66386 20.3249 1.53193 20.3939 1.41969C20.4707 1.29761 20.591 1.19522 20.7545 1.10267C20.926 1.01013 21.1487 0.949086 21.4147 0.907736C21.6887 0.866386 22.0493 0.846695 22.4967 0.846695C22.883 0.846695 23.218 0.866386 23.5018 0.907736C23.7856 0.949086 24.0083 1.01013 24.162 1.10267C24.3256 1.19522 24.436 1.29761 24.5148 1.41969C24.5838 1.53193 24.6173 1.66582 24.6173 1.8076V37.4968Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_51_5340)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.6173 0.846695H0V39.8361H24.6173V0.846695Z",
    fill: "url(#paint1_linear_51_5340)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_51_5340",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 0,
    width: 26,
    height: 40
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M76.9064 19.7851C76.9064 17.6585 76.7606 15.6718 76.4689 13.8425C76.1772 12.0152 75.6944 10.4242 75.0125 9.07343C74.3306 7.7325 73.426 6.67905 72.2908 5.92293C71.1477 5.16878 69.7445 4.79072 68.0733 4.79072C66.3941 4.79072 64.9909 5.19832 63.8557 6.01351C62.7206 6.8287 61.7923 7.91168 61.0887 9.26246C60.3753 10.6231 59.8688 12.2042 59.5633 14.0217C59.2559 15.8293 59.1041 17.7275 59.1041 19.7241C59.1041 21.9393 59.25 23.9674 59.5338 25.8242C59.8176 27.6929 60.2925 29.2917 60.9665 30.6425C61.6327 31.9835 62.5392 33.0271 63.6646 33.7714C64.7919 34.5157 66.2109 34.8937 67.9117 34.8937C69.6065 34.8937 71.0255 34.4861 72.1745 33.6709C73.3255 32.8557 74.2517 31.7629 74.9573 30.3728C75.6549 28.9924 76.1614 27.3818 76.459 25.5643C76.7606 23.7508 76.9064 21.8231 76.9064 19.7851ZM80.9998 19.4386C80.9998 22.4886 80.7238 25.2315 80.172 27.6751C79.6123 30.1188 78.7846 32.1961 77.6868 33.9151C76.5832 35.6242 75.2036 36.9455 73.5383 37.869C71.8749 38.7925 69.9357 39.2493 67.7185 39.2493C65.5329 39.2493 63.6468 38.8318 62.0525 37.9871C60.4502 37.1424 59.1396 35.9098 58.0971 34.301C57.0545 32.6923 56.28 30.6937 55.7735 28.3092C55.2591 25.9247 55.0068 23.1817 55.0068 20.0824C55.0068 17.1111 55.2828 14.4096 55.8346 11.9837C56.3943 9.55979 57.222 7.50212 58.3336 5.80282C59.4372 4.11336 60.8246 2.80197 62.49 1.87848C64.1454 0.954991 66.0867 0.498169 68.3098 0.498169C70.4481 0.498169 72.3125 0.91561 73.899 1.75049C75.4855 2.58537 76.8118 3.79635 77.8622 5.39719C78.9206 6.99607 79.7108 8.97498 80.2233 11.3398C80.7396 13.6948 80.9998 16.3983 80.9998 19.4386Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_51_5340)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M81.0017 0.500313H55.0088V39.2514H81.0017V0.500313Z",
    fill: "url(#paint2_linear_51_5340)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_51_5340",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 26,
    width: 26,
    height: 13
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M27.6763 33.0133L51.4875 26.604C51.9566 26.478 52.4414 26.7851 52.4591 27.2695L52.6069 31.312C52.6247 31.7964 51.9842 31.8161 51.5171 31.946L27.8418 38.5227C27.3748 38.6527 27.1619 38.2549 27.1501 37.7705L27.0535 34.0923C27.0397 33.6079 27.2072 33.1393 27.6763 33.0133Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_51_5340)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M52.625 26.4759H27.04V38.6506H52.625V26.4759Z",
    fill: "url(#paint3_linear_51_5340)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_51_5340",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 13,
    width: 26,
    height: 13
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M27.6763 19.7733L51.4875 13.364C51.9566 13.238 52.4414 13.5452 52.4591 14.0296L52.6069 18.072C52.6247 18.5564 51.9842 18.5761 51.5171 18.7061L27.8418 25.2827C27.3748 25.4127 27.1619 25.0149 27.1501 24.5306L27.0535 20.8524C27.0397 20.368 27.2072 19.8993 27.6763 19.7733Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_51_5340)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M52.625 13.2379H27.04V25.4126H52.625V13.2379Z",
    fill: "url(#paint4_linear_51_5340)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_51_5340",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 0,
    width: 26,
    height: 13
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_19_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M27.6763 6.53537L51.4875 0.126079C51.9566 5.89043e-05 52.4414 0.307232 52.4591 0.791621L52.6069 4.8341C52.6247 5.31849 51.9842 5.33818 51.5171 5.46617L27.8418 12.0428C27.3748 12.1728 27.1619 11.775 27.1501 11.2907L27.0535 7.61245C27.0397 7.13003 27.2072 6.66139 27.6763 6.53537Z",
    fill: "white"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_51_5340)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M52.625 0H27.04V12.1747H52.625V0Z",
    fill: "url(#paint5_linear_51_5340)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_51_5340",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 16,
    width: 3,
    height: 10
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M63.8857 24.5089V17.7294C63.8857 17.377 63.9586 17.1151 64.1064 16.9379C64.2522 16.7606 64.4433 16.674 64.6778 16.674C64.9162 16.674 65.1113 16.7606 65.259 16.9339C65.4068 17.1092 65.4836 17.373 65.4836 17.7294V24.5089C65.4836 24.8653 65.4088 25.1311 65.259 25.3064C65.1113 25.4836 64.9162 25.5702 64.6778 25.5702C64.4492 25.5702 64.2601 25.4816 64.1104 25.3044C63.9606 25.1272 63.8857 24.8614 63.8857 24.5089Z",
    fill: "white"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_51_5340)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M65.4817 16.674H63.8857V25.5722H65.4817V16.674Z",
    fill: "url(#paint6_linear_51_5340)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_51_5340",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 16,
    width: 7,
    height: 10
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_27_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M69.3051 17.9125V18.1764C69.5987 17.6704 69.9219 17.3021 70.2688 17.0658C70.6176 16.8296 71.0177 16.7134 71.471 16.7134C71.9124 16.7134 72.3046 16.8374 72.6535 17.0875C73.0003 17.3356 73.2585 17.6881 73.43 18.1449C73.5403 18.4107 73.6113 18.6962 73.6448 19.0073C73.6763 19.3145 73.6921 19.7064 73.6921 20.1848V24.2313C73.6921 24.6664 73.6152 24.9953 73.4615 25.2178C73.3097 25.4403 73.1087 25.5525 72.8643 25.5525C72.616 25.5525 72.413 25.4383 72.2573 25.2099C72.1036 24.9815 72.0248 24.6546 72.0248 24.2313V20.6062C72.0248 19.8915 71.9479 19.3421 71.7942 18.9621C71.6424 18.584 71.337 18.395 70.8797 18.395C70.5841 18.395 70.3121 18.5092 70.0658 18.7396C69.8214 18.9699 69.6421 19.2889 69.5297 19.6926C69.4489 20.0155 69.4056 20.62 69.4056 21.5081V24.2313C69.4056 24.6723 69.3268 25.0012 69.1691 25.2197C69.0134 25.4403 68.8104 25.5505 68.564 25.5505C68.3236 25.5505 68.1265 25.4363 67.9708 25.2079C67.8171 24.9795 67.7383 24.6526 67.7383 24.2293V17.9441C67.7383 17.5305 67.8073 17.2214 67.9452 17.0166C68.0851 16.8118 68.2724 16.7094 68.5128 16.7094C68.6587 16.7094 68.7927 16.7547 68.9089 16.8453C69.0272 16.9359 69.1218 17.0718 69.1927 17.2509C69.2696 17.4321 69.3051 17.6546 69.3051 17.9125Z",
    fill: "white"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_51_5340)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M73.692 16.7116H67.7422V25.5487H73.692V16.7116Z",
    fill: "url(#paint7_linear_51_5340)"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M64.7467 15.4985C64.5142 15.4985 64.3152 15.4237 64.1477 15.274C63.9783 15.1244 63.8955 14.9137 63.8955 14.6459C63.8955 14.4155 63.9763 14.2206 64.1379 14.0552C64.2994 13.8898 64.4984 13.809 64.7348 13.809C64.9713 13.809 65.1722 13.8898 65.3377 14.0532C65.5052 14.2166 65.586 14.4135 65.586 14.6478C65.586 14.9117 65.5033 15.1204 65.3377 15.272C65.1683 15.4217 64.9732 15.4985 64.7467 15.4985Z",
    fill: "#00E9E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_5340",
    x1: 0,
    y1: 20.3421,
    x2: 24.6181,
    y2: 20.3421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#00DBE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#00B7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7029,
    stopColor: "#007ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_5340",
    x1: 12.661,
    y1: 2.39607,
    x2: 11.9744,
    y2: 37.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#00DBE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#00B7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7029,
    stopColor: "#007ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_51_5340",
    x1: 69.0235,
    y1: 3.20582,
    x2: 66.8692,
    y2: 38.4857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_51_5340",
    x1: 27.8477,
    y1: 33.5554,
    x2: 51.7198,
    y2: 31.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0044C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_51_5340",
    x1: 27.8477,
    y1: 20.3171,
    x2: 51.7197,
    y2: 18.3387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0044C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_51_5340",
    x1: 27.8478,
    y1: 7.07982,
    x2: 51.7198,
    y2: 5.0994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0044C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_51_5340",
    x1: 64.7067,
    y1: 17.1895,
    x2: 64.6654,
    y2: 24.2387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_51_5340",
    x1: 70.6365,
    y1: 17.3161,
    x2: 70.8076,
    y2: 25.3065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0044C6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_5340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 39.8361,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.26858f66cad582c93626202d997c9721.svg";
export { ForwardRef as ReactComponent };